import * as yup from 'yup';

const emailSchema = yup.string()
  .trim()  // Removes whitespace before and after the string
  .strict(true)  // Ensures no additional trimming happens after this point
  .required("Email is required")
  .test(
    'no-trailing-or-leading-spaces',
    'Email cannot have leading or trailing spaces',
    function(value) {
      if (value !== value.trim()) {
        return false;
      }
      return true;
    }
  )
  .email('Invalid email')
  .test(
    'invalid-email',
    'Invalid email',
    function (value) {
      if (!value) return false;

      // Regular expression to match valid email addresses
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      
      // Disallowed patterns in the local part of the email
      const disallowedPatterns = ["-@",  "_@",  "%@", "&@", "+@"];

      // Regular expression to prevent special characters at the start
      const specialCharStartRegex = /^[._%+-]/;

      // Check if the email starts with a special character
      if (specialCharStartRegex.test(value)) {
        return false;
      }

      // Check for disallowed patterns
      for (const pattern of disallowedPatterns) {
        if (value.includes(pattern)) {
          return false;
        }
      }

      // Validate the general email format
      if (!emailRegex.test(value)) {
        return false;
      }

      const [localPart] = value.split("@");

      // Check if the local part ends with a dot or hyphen
      if (localPart.endsWith(".") || localPart.endsWith("-")) {
        return false;
      }

      // Check for multiple consecutive dots in the local part
      if (localPart.includes("..")) {
        return false;
      }

      return true;
    }
  );

export default emailSchema;
